import React, { FC } from "react";
import styled from "styled-components";
import styles from './Header.module.css';

const Wrapper = styled.div`
  height: 12px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  position: relative;
  padding-top: 8px;
`;

const Handle = styled.div`
  width: 50px;
  height: 4px;
  border-radius: 3px;
  background-color: #d0d0d0;
  margin: auto;
`;

interface SelectedOption {
  sub_category: string;
}

interface Hotple {
  id: number;
  name: string;
  sub_category1: string;
  sub_category2?: string; // 선택적 필드
  mention_count: number;
  preview_url?: string;
  contents_url?: string[];
  main_category: string;
  tags?: string[];
  place_name?: string;
  address?: string;
  region: string;
  caption: string;
  latitude?: number;
  longitude?: number;
  media_url?: string;
  has_period?: boolean;
  need_verify?: boolean;
  taggedBy?: string;
  verify_results?: any[]; // 타입을 더 구체적으로 정의 가능
  kakao_map_place_id?: string;
  comment?: string;
}

interface BottomSheetHeaderProps {
  activeMenu: string;
  rangeHotples: { hotples: Hotple[] };
  myHotples: { hotples: Hotple[] };
  adminHotples: { hotples: Hotple[] };
  selectedOption: { sub_category: string, category: string, filter: string, region: string };
  setSelectedOption: React.Dispatch<React.SetStateAction<SelectedOption>>;
  selectedHotple: { sub_category1: string };
  stickyFilter: boolean;
}

const BottomSheetHeader: FC<BottomSheetHeaderProps> = ({ 
  activeMenu, 
  rangeHotples,
  myHotples,
  adminHotples,
  selectedOption, 
  setSelectedOption,
  selectedHotple,
  stickyFilter
}) => {
  const toggleSubCategoryOption = (category: string) => {
    if(selectedOption.sub_category == 'all' && category == 'all')
			return;

    setSelectedOption((prev: SelectedOption) => ({
      ...prev,
      sub_category: prev.sub_category === category ? 'all' : category
    }));
  };

  const getFilteredMapHotples = (hotples: Hotple[]): Hotple[] => {
    if(activeMenu=='home'){
      return hotples;
    }
    else{
      let category_kor: string;
      switch(selectedOption.category) {
        case "cafe":
            category_kor='카페디저트'
            break;
        case "alcohol":
            category_kor='주점'
            break;
        case "restaurant":
            category_kor='음식점'
            break;
        case "popupStore":
            category_kor='팝업스토어'
            break;
        case "cultural":
            category_kor='문화예술'
            break;
        case "activity":
            category_kor='오락액티비티'
            break;
        case "rest":
            category_kor='휴식힐링'
            break;
        case "accommodation":
            category_kor='숙소'
            break;
        default:
            category_kor='추천'
      }

      let filteredHotples = hotples;

      if(selectedOption.region!='전국' && selectedOption.region!='위치'){
        filteredHotples = filteredHotples.filter(hotple => hotple.region == selectedOption.region)
      }

      if(selectedOption.category!='recommend' && !selectedOption.category.startsWith('@'))
        filteredHotples = filteredHotples.filter(hotple => hotple.main_category == category_kor)

      if(activeMenu=='my' || activeMenu=='admin'){
        switch(selectedOption.filter){
          case null:
          case 'all':
            break;
          case 'need_verify':
            filteredHotples = filteredHotples.filter(hotple => hotple.need_verify == true)
            break;
          case 'my_pick':
            if(activeMenu=='admin')
              setSelectedOption((prev)=>({...prev, filter:'all'}))
            else
              filteredHotples = filteredHotples.filter(hotple => hotple.taggedBy == null)
            break;
          case 'has_period':
            filteredHotples = filteredHotples.filter(hotple => hotple.has_period == true)
            break;
          case 'edit_request':
            if(activeMenu=='my')
              setSelectedOption((prev)=>({...prev, filter:'all'}))
            else
              filteredHotples = filteredHotples.filter(hotple => hotple.verify_results && hotple.verify_results.length>0)
            break;
          case 'err_image':
            if(activeMenu=='my')
              setSelectedOption((prev)=>({...prev, filter:'all'}))
            else
              filteredHotples = filteredHotples.filter(hotple => !hotple.preview_url || !hotple.contents_url || hotple.contents_url.length==0)
            break;
          case 'err_info':
            if(activeMenu=='my')
              setSelectedOption((prev)=>({...prev, filter:'all'}))
            else
              filteredHotples = filteredHotples.filter(hotple => !hotple.name || !hotple.caption || !hotple.main_category || !hotple.sub_category1 || !hotple.sub_category2 || !hotple.tags || !hotple.place_name || !hotple.address || !hotple.region || !hotple.latitude || !hotple.longitude|| !hotple.media_url)
            break;
          case 'err_place':
            if(activeMenu=='my')
              setSelectedOption((prev)=>({...prev, filter:'all'}))
            else
              filteredHotples = filteredHotples.filter(hotple => hotple.address && !((hotple.region == hotple.address.substring(0,2)) || hotple.region == hotple.address.charAt(0) + hotple.address.charAt(2)))
            break;
          case 'err_kakao':
            if(activeMenu=='my')
              setSelectedOption((prev)=>({...prev, filter:'all'}))
            else
              filteredHotples = filteredHotples.filter(hotple => !hotple.kakao_map_place_id)
            break;
          default:  //username인 경우
            filteredHotples = filteredHotples.filter(hotple => (hotple.taggedBy == selectedOption.filter || (hotple.comment && hotple.comment.includes(selectedOption.filter))))
        }
      }

      return filteredHotples;
    }
  };

  return (
    <Wrapper style={
      (activeMenu=='search' && selectedHotple == null) ||
      (stickyFilter && activeMenu=='my' && selectedHotple == null) ||
      (stickyFilter && activeMenu=='admin' && selectedHotple == null)
      ? {height: '60px'} : undefined}>
        <Handle/>
        <div className={styles.tagButtonFrame}>
          {(activeMenu=='search' || (activeMenu!='search' && stickyFilter)) && activeMenu != 'shop' && <div className={selectedOption.sub_category == 'all' ? styles.buttonActive : styles.button} key='all' onClick={()=>toggleSubCategoryOption('all')}>전체</div>}
          {activeMenu=='search' && selectedHotple == null && [...new Set(rangeHotples.hotples.map(hotple => hotple.sub_category1))].map((category, index) => (
            <div className={selectedOption.sub_category == category ? styles.buttonActive : styles.button} key={category} onClick={()=>toggleSubCategoryOption(category)}>#{category}</div>
          ))}
          {stickyFilter && activeMenu=='my' && selectedHotple == null && [...new Set(getFilteredMapHotples(myHotples.hotples).map(hotple => hotple.sub_category1))].map((category, index) => (
            <div className={selectedOption.sub_category == category ? styles.buttonActive : styles.button} key={category} onClick={()=>toggleSubCategoryOption(category)}>#{category}</div>
          ))}
          {stickyFilter && activeMenu=='admin' && selectedHotple == null && [...new Set(getFilteredMapHotples(adminHotples.hotples).map(hotple => hotple.sub_category1))].map((category, index) => (
            <div className={selectedOption.sub_category == category ? styles.buttonActive : styles.button} key={category} onClick={()=>toggleSubCategoryOption(category)}>#{category}</div>
          ))}
        </div>
    </Wrapper>
  );
};

export default BottomSheetHeader;